import Splide from "@splidejs/splide";
import { gsap } from "gsap";

window.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".splide")) {
        const slidersWithCaption = document.querySelectorAll(".slider-captions .splide");
        const sliderWithDots = document.querySelectorAll(".slider-dots .splide");
        const slidersClassrooms = document.querySelectorAll(".slider-classrooms .splide");
        const slidersClassroomsControls = Array.from(
            document.querySelectorAll(".slider-classrooms .slider-controls button:not(.slider-control-control)")
        );
        const sliderControlDropdown = document.querySelector(".slider-controls .slider-control-dropdown");

        const getActiveControl = (current) =>
            slidersClassroomsControls.filter((button) => button.classList.contains("active") && button !== current);

        for (let i = 0; i < slidersWithCaption.length; i++) {
            new Splide(slidersWithCaption[i], {
                type: "loop",
                perPage: 1,
                perMove: 1,
                pagination: false,
            }).mount();
        }

        for (let i = 0; i < sliderWithDots.length; i++) {
            const splide = new Splide(sliderWithDots[i], {
                type: "loop",
                perPage: 1,
                perMove: 1,
                pagination: true,
            });

            splide.on("pagination:mounted", function (data) {
                data.items.forEach((item) => {
                    const query = item.button.getAttribute("aria-controls");
                    const title = document.getElementById(query).getAttribute("data-dot-title");
                    const span = document.createElement("span");
                    span.classList.add("h5");
                    span.classList.add("monospace");
                    span.innerHTML = title;
                    //console.log(span);
                    item.button.appendChild(span);
                    item.button.classList.add("button", "secondary-button");
                });
            });

            splide.mount();
        }

        for (let i = 0; i < slidersClassrooms.length; i++) {
            const controlId = slidersClassrooms[i].firstElementChild.id;
            const controls = document.querySelectorAll(`[aria-controls=${controlId}]`);
            //console.log(controls);

            //console.log(slidersClassroomsControls);
            //console.log(document.getElementById(slidersClassrooms[i].firstElementChild.id));

            const slide = new Splide(slidersClassrooms[i], {
                type: "loop",
                perPage: 1,
                perMove: 1,
                pagination: false,
            });
            slide.mount();

            controls.forEach((control) => {
                control.addEventListener("click", () => {
                    const previousControlsActive = getActiveControl(control);

                    if (previousControlsActive) {
                        previousControlsActive.forEach((previousControlActive) => {
                            previousControlActive.classList.remove("active");
                            previousControlActive.removeAttribute("disabled");
                            const previousSlide = document.querySelector(
                                `#${previousControlActive.getAttribute("aria-controls")}`
                            ).parentElement;
                            previousSlide.setAttribute("data-slider-enabled", "false");
                        });
                    }
                    control.classList.add("active");
                    control.toggleAttribute("disabled");
                    const currentControlLabel = control.firstElementChild.innerHTML;

                    const sliderControlOpener = sliderControlDropdown.querySelector(".slider-control-control");
                    sliderControlOpener.firstElementChild.innerHTML = currentControlLabel;
                    const newSlider = document.querySelector(`#${control.getAttribute("aria-controls")}`).parentElement;
                    newSlider.setAttribute("data-slider-enabled", "true");
                });
            });
        }

        if (sliderControlDropdown) {
            const sliderControlOpener = sliderControlDropdown.querySelector(".slider-control-control");
            const sliderDropdownList = sliderControlDropdown.querySelector(".slider-control-list");

            function openDropdown() {
                gsap.to(sliderDropdownList, { height: "auto", autoAlpha: 1, duration: 0.3, ease: "power2.inOut" });
            }

            function closeDropdown() {
                gsap.to(sliderDropdownList, {
                    height: 0,
                    autoAlpha: 0,
                    duration: 0.3,
                    delay: 0.3,
                    ease: "power2.inOut",
                });
            }

            gsap.set(sliderDropdownList, { height: 0, autoAlpha: 0 });

            sliderControlOpener.addEventListener("click", (event) => {
                event.stopImmediatePropagation();
                let expanded = sliderControlOpener.getAttribute("aria-expanded") === "true";

                sliderControlOpener.setAttribute("aria-expanded", !expanded);

                if (sliderControlOpener.getAttribute("aria-expanded") === "true") {
                    openDropdown();
                } else {
                    closeDropdown();
                }
            });

            window.addEventListener("click", (event) => {
                event.stopPropagation();
                if (sliderControlOpener.getAttribute("aria-expanded") === "false") return;
                sliderControlOpener.setAttribute("aria-expanded", false);
                closeDropdown();
            });
        }
    }
});
